import { render, staticRenderFns } from "./AssignchildVue.vue?vue&type=template&id=14973f40&scoped=true&"
import script from "./AssignchildVue.vue?vue&type=script&lang=js&"
export * from "./AssignchildVue.vue?vue&type=script&lang=js&"
import style0 from "./AssignchildVue.vue?vue&type=style&index=0&id=14973f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14973f40",
  null
  
)

export default component.exports